var _a;
import { HomePagePreview } from '../_components/home-page-preview';
import { SimpleContentPreview } from '../_components/simple-content-preview';
export var PREVIEW_VARIANS = {
    'home-page': 'home-page',
    'simple-content': 'simple-content',
};
export var PREVIEWS = (_a = {},
    _a[PREVIEW_VARIANS['home-page']] = HomePagePreview,
    _a[PREVIEW_VARIANS['simple-content']] = SimpleContentPreview,
    _a);
